import { Alert } from 'shared/ui'
import { type IAlertButtonAction, type IAlert } from 'shared/ui/Alert/types'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { openIntercomNewMessage } from 'entities/Intercom'
import { ChatbotStatus, type IChatbotFullData } from 'entities/Chatbot'
import { type ChatbotAnalyticDetailStore } from 'pages/chatbot/pages/chatbotAnalytic/store'

type IChatbotInvalidAlertProps = {
  className?: string
  data: IChatbotFullData | ChatbotAnalyticDetailStore
  isBottomActions?: boolean
}

export const ChatbotInvalidAlert = ({
  className,
  data,
  isBottomActions,
}: IChatbotInvalidAlertProps) => {
  if (data.status !== ChatbotStatus.Invalid) return null

  const info: Partial<IAlert> = {
    title: 'Suspicious content detected',
    desc: 'Your link has been flagged as spam. If you believe this is an error, contact support for assistance.',
  }

  const handleOpenIntercomWidget = () => {
    openIntercomNewMessage()

    modalStore.closeAllModals()
  }

  const action = (): IAlertButtonAction => {
    return {
      variant: 'button',
      type: 'primary',
      text: 'Support',
      onClick: handleOpenIntercomWidget,
    }
  }

  return (
    <div className={className}>
      <Alert
        item={{
          type: 'alert',
          ...info,
        }}
        rightActions={!isBottomActions ? [action()] : undefined}
        actions={isBottomActions ? [action()] : undefined}
      />
    </div>
  )
}
